import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  FETCH_TENANT_LIST,
  SHOW_INFO_DIALOG,
  CREATE_TENANT,
  UPDATE_TENANT,
  SHOW_TENANT_BALANCE_DIALOG,
  SHOW_TENANT_CREDIT_DIALOG,
  SHOW_RECHARGE_BALANCE_DIALOG,
  FETCH_STAFF_CONVS,
  REGISTER_TENANT
} from './actionTypes'
// import { getSessionList } from './selectors'
import * as services from './services'
import * as actions from './actions'
import { message } from 'antd'
const isManagerMode = process.env.APP_MODE === 'manager';
export default {
  *[FETCH_TENANT_LIST]({ payload }) {
    const { params } = payload
    yield actions.toggleLoading()
    const { data, total } = yield call(services.fetchTenants, params)
    yield put(actions.tenantListFetched({ data, total }))
    yield actions.toggleLoading()
  },


  *[FETCH_STAFF_CONVS]({ payload }) {
    const { params } = payload
    yield actions.toggleLoading()
    const { data } = yield call(services.fetchStaffConvs, params)
    yield put(actions.staffConvsFetched({ data }))
    yield actions.toggleLoading()
  },

  *[CREATE_TENANT]({ payload }) {
    const result = yield call(services.createTenant, payload)
    const tenant = yield call(services.getTenantById, result._id)
    message.success('已创建')
    yield put(actions.tenantCreated(tenant))
  },

  *[REGISTER_TENANT]({ payload }) {
    const result = yield call(services.registerTenant, payload)
    if(result._id){
      message.success('创建成功')
      localStorage.removeItem(`next_to_register`)//注册完成
    } else {
      message.success('创建失败')
    }
    window.location.reload()
  },
  *[UPDATE_TENANT]({ payload }) {
    const { id, data } = payload
    yield call(services.updateTenantById, id, data)

    const tenant = yield call(services.getTenantById, id)
    message.success('更新成功')
    if(isManagerMode){
      yield put(actions.tenantUpdated(id, tenant))
    }
  },

  *[SHOW_INFO_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('TENANT_INFO_DIALOG')
    if (params.id) {
      const tenant = yield call(services.getTenantById, params.id)
      if(isManagerMode){
        yield put(actions.tenantUpdated(params.id, tenant))
      }
      params.tenant = tenant
    }

    yield modal.show(params)

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[SHOW_TENANT_BALANCE_DIALOG]({ payload }) {
    const { params } = payload
    const { tenant } = params
    const modal = createModal('CHANGE_BALANCE_DIALOG')
    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (!submit) {
      return yield modal.destroy()
    }

    try {
      yield call(services.changeBalance, tenant._id, submit.payload)
    } catch(err) {
      yield modal.destroy()
      throw err
    }

    // update order info
    const tenantData = yield call(services.getTenantById, tenant._id)
    yield put(actions.tenantUpdated(tenant._id, tenantData))

    yield modal.hide()

    message.success('已更新')
  },
  *[SHOW_TENANT_CREDIT_DIALOG]({ payload }) {
    const { params } = payload
    const { tenant } = params
    const modal = createModal('TENANT_CREDIT_DIALOG')
    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (!submit) {
      return yield modal.destroy()
    }

    try {
      yield call(services.changeCredit, tenant._id, submit.payload)
    } catch(err) {
      yield modal.destroy()
      throw err
    }

    // update order info
    const tenantData = yield call(services.getTenantById, tenant._id)
    yield put(actions.tenantUpdated(tenant._id, tenantData))

    yield modal.hide()

    message.success('已更新')
  },
  // t端充值弹出框
  *[SHOW_RECHARGE_BALANCE_DIALOG]({ payload }) {
    const { params } = payload
    const { worker } = params
    const modal = createModal('RECHARGE_DIALOG')
    yield modal.show(params)

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (!submit) {
      return yield modal.destroy()
    }

    try {
      // yield call(services.changeBalance, worker._id, submit.payload)
    } catch(err) {
      yield modal.destroy()
      throw err
    }

    // update order info
    // const workerData = yield call(services.findById, worker._id)
    // yield put(actions.updated(worker._id, workerData))

    yield modal.hide()

    message.success('已更新')
  },
}
